export default __webpack_public_path__ + "static/media/Foundation_Glass.256.cd1da0c8.png";